/*
 * Registro do service worker da Dinâmica (D190), como o do hub. Só no build de produção.
 *
 * Sem avisos próprios do PWA: sem internet, vale o aviso do shell do @winieduca/ui (D162); a navegação busca a
 * página na rede primeiro (sw.js), então a versão nova chega a cada abertura e o service worker novo assume
 * sozinho quando as abas fecham; instalar fica pelo menu do navegador. Um convite para instalar no momento
 * certo é melhoria registrada com gatilho (D190; blueprint §9.4, item 3.7).
 */
export function registerPWA() {
  if (!("serviceWorker" in navigator)) return;
  if (!import.meta.env.PROD) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
      /* Sem service worker, a Dinâmica funciona igual; só não abre sem internet. */
    });
  });
}
